import React from 'react';

import { GetFluxNextExecutionTimeResponseDtoFluxTypeEnum } from 'lib_api/lib/api/gen';

import { FluxDisplayName } from 'enums/flux/FluxDisplayName';

import DashboardFluxAlienation from '../shared/components/DashboardFluxAlienation';

import { useSearchFluxsAutoritesFourriere } from './utils';

function DashboardFluxAutoriteFourriere(): React.ReactElement {
  return (
    <DashboardFluxAlienation
      useSearchFluxs={useSearchFluxsAutoritesFourriere}
      buildSpecificTableColumns={() => []}
      tableTitle={FluxDisplayName.ALIENATION_AUTORITE_FOURRIERE}
      fluxType={
        GetFluxNextExecutionTimeResponseDtoFluxTypeEnum.ALIENATION_ENTITE_REMETTANTE
      }
      keyPagination={'paginationFluxAlienationEntitesRemettantes'}
    />
  );
}

export default DashboardFluxAutoriteFourriere;
